import { Box, Heading, NumberInput, NumberInputField } from '@chakra-ui/react';
import { FC } from 'react';
import { useStore } from '../../../hooks/useStore';
import { shallow } from 'zustand/shallow';
import { AdElementText } from '@adflow/types';

type YPositionInputProps = {
  selectedElement: AdElementText;
};

const YPositionInput: FC<YPositionInputProps> = ({ selectedElement }) => {
  const store = useStore(
    (state) => ({
      selectedElementId: state.selectedElementId,
      updateElementPosition: state.updateElementPosition,
    }),
    shallow,
  );

  const handleYPositionChange = (yPosition: string): void => {
    const yPositionValue: number = parseFloat(yPosition);

    const isValidCoordinate = yPositionValue >= 0;

    store.updateElementPosition(
      selectedElement.id,
      selectedElement.position.x,
      isValidCoordinate ? yPositionValue : 0,
    );
  };

  const handleArrowsForYPosition = (event: React.KeyboardEvent<HTMLInputElement>): void => {
    const { key, target } = event;
    if (key === 'ArrowUp' || key === 'ArrowDown') {
      handleYPositionChange((target as HTMLInputElement).value);
    }
  };

  return (
    <Box display="flex" flexDirection="column">
      <Heading fontSize="md" fontWeight="semibold">
        Y position
      </Heading>
      <NumberInput
        defaultValue={selectedElement.position.y || 0}
        size="sm"
        width={20}
        variant="outline"
        mt={2}
        precision={0}
        min={0}
      >
        <NumberInputField
          data-test-id="y-position-input"
          onChange={(e) => handleYPositionChange(e.target.value)}
          onKeyUp={handleArrowsForYPosition}
        />
      </NumberInput>
    </Box>
  );
};

YPositionInput.displayName = 'YPositionInput';

export default YPositionInput;
